import k from '../constants/k'
import type { Ingredient } from '../constants/ingredients'

export const w = k.width()
export const h = k.height()

export const ingredients: Array<Ingredient> = [
  undefined,
  undefined,
  undefined,
  undefined,
  undefined,
  undefined,
  undefined
]

export const inCauldron: Array<Ingredient> = []

export const times = {
  startTime: null,
  endTime: null
}

export const score = {
  potionsMade: 0,
  mistakes: 0,
  ingredientsFound: 0
}
